// react native
import { Platform } from 'react-native';

// @polls-platform/core
import { EmbeddedState } from '@polls-platform/core/built/internal';

const getEmbeddedState = (): EmbeddedState => {
  return Platform.select({
    android: EmbeddedState.SDK_MOBILE_APP_ANDROID,
    ios: EmbeddedState.SDK_MOBILE_APP_IOS,
    default: EmbeddedState.SDK_MOBILE_APP_IOS,
  });
};

export { getEmbeddedState };
